// src/utils/axiosInstance.js
import axios from "axios"

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("Token")
  if (token) {
    config.headers = {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json; charset=UTF-8",
    }
  }
  return config
})

export default api
